import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 18.26l-7.05 3.95 1.57-7.93L.6 8.79l8.02-.95L12 .5l3.39 7.34 8.02.95-5.93 5.49 1.57 7.93L12 18.26zm0-2.3l4.25 2.38-.95-4.77 3.57-3.3-4.83-.58L12 5.28 9.96 9.7l-4.83.57 3.57 3.3-.95 4.77L12 15.97z"/>
  </SvgIcon>
);